import { type ReactElement } from 'react';
import { Download } from 'lucide-react';
import { useAuthedBlobUrl } from '@/lib/hooks/use-authed-blob-url';

export function AuthedAudio({ downloadUrl }: { downloadUrl: string }): ReactElement {
  const { url, isError } = useAuthedBlobUrl(downloadUrl);

  if (isError) {
    return <p className="text-sm text-[var(--err)]" role="alert">Couldn’t load audio.</p>;
  }
  if (url === null) {
    return <p className="text-sm text-[var(--ink-3)]" aria-live="polite">Loading audio…</p>;
  }
  return (
    <audio controls className="w-full" src={url}>
      <track kind="captions" />
    </audio>
  );
}

export function AuthedDownloadLink({ downloadUrl, label }: { downloadUrl: string; label: string }): ReactElement {
  const { url, isError } = useAuthedBlobUrl(downloadUrl);

  if (isError) {
    return <p className="text-sm text-[var(--err)]" role="alert">Couldn’t load file.</p>;
  }
  if (url === null) {
    return <p className="text-sm text-[var(--ink-3)]" aria-live="polite">Loading…</p>;
  }
  return (
    <a
      href={url}
      download={label}
      className="flex items-center gap-1 text-sm text-[var(--brand)] hover:underline"
    >
      <Download className="h-3 w-3" />
      Download PDF
    </a>
  );
}
